/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Style Imports
 */
import {
  NotesContainer,
  NotesHeader,
  NotesHeaderContainer,
  NotesContent,
  NoteIcon,
  IconsContainer
} from './NotesCard.styles';

interface NotesCardProps {
  date: string;
  noteId: string;
  author: string;
  message: string;
  deleteNote: Dispatch<SetStateAction<string>>;
}
const NotesCard: FC<NotesCardProps> = ({
  date,
  noteId,
  author,
  message,
  deleteNote
}) => {
  return (
    <NotesContainer data-testid={`notes-container-${noteId}`} className="p-2">
      <NotesHeaderContainer data-testid={`notes-header-${noteId}`}>
        <NotesHeader className="my-0">{`${date} - ${author}`}</NotesHeader>
        <IconsContainer>
          <NoteIcon onClick={() => deleteNote(noteId)}>
            {' '}
            delete_outline{' '}
          </NoteIcon>
        </IconsContainer>
      </NotesHeaderContainer>
      <NotesContent
        data-testid={`notes-content-${noteId}-${author}`}
      >{`${message}`}</NotesContent>
    </NotesContainer>
  );
};

// export default AddIssueFromPatientRound;
export default NotesCard;
